export default "__VITE_ASSET__DXJdICZN__"